<script setup lang="ts">
interface Props {
  unreadCount: number
}

const props = defineProps<Props>()
</script>

<template>
  <div class="p-3 d-flex justify-content-between align-items-center bg-white">
    <strong class="fs-14 text-dark">{{ $t('notification.header.title') }}</strong>
    <span class="text-primary font-weight-bold fs-12">
      {{ $t('notification.header.unread', { count: unreadCount }) }}
    </span>
  </div>
</template>
